import React, { Component } from 'react';
import { Switch } from 'react-router-dom';

import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import AnonRoute from './components/AnonRoute';
import Private from './pages/Private';
import Login from './pages/Login';
import { withAuth } from './providers/AuthProvider';
import Main from './pages/Main';
import Welcome from './pages/Welcome';
import Vote from './pages/Vote';
import Gig from './pages/Gig';
import SongOrder from './pages/SongOrder';
import Header from './components/Header';
import NewSong from './pages/NewSong';
import SongCrossroad from './pages/SongCrossroad';
import Jukebox from './pages/Jukebox';
import EditSong from './pages/EditSong';
import PublicRanking from './pages/PublicRanking';

class App extends Component {
	
	render() {
		const { isLoading } = this.props;
		if (isLoading) {
			return <div>loading ... </div>;
		}

		return (
			<div className="h-screen">
				<Header />
				<Navbar />
				<Switch>
					<AnonRoute path="/cat/ranking" component={PublicRanking} />
					<AnonRoute path="/cas/ranking" component={PublicRanking} />
					<AnonRoute path="/en/ranking" component={PublicRanking} />
					<AnonRoute path="/fr/ranking" component={PublicRanking} />
					<AnonRoute path="/de/ranking" component={PublicRanking} />

					<AnonRoute path="/cat/vote" component={Vote} />
					<AnonRoute path="/cas/vote" component={Vote} />
					<AnonRoute path="/en/vote" component={Vote} />
					<AnonRoute path="/fr/vote" component={Vote} />
					<AnonRoute path="/de/vote" component={Vote} />

					<AnonRoute path="/cat" component={Welcome} />
					<AnonRoute path="/cas" component={Welcome} />
					<AnonRoute path="/en" component={Welcome} />
					<AnonRoute path="/fr" component={Welcome} />
					<AnonRoute path="/de" component={Welcome} />
					
					<AnonRoute path="/login" component={Login} />
					
					<PrivateRoute path="/gig" component={Gig} />
					<PrivateRoute path="/order" component={SongOrder} />
					<PrivateRoute path="/repertoire" component={SongCrossroad} />
					<PrivateRoute path="/newsong" component={NewSong} />
					<PrivateRoute path="/admin" component={Private} />
					<PrivateRoute path="/jukebox" component={Jukebox} />
					<PrivateRoute path="/:id" component={EditSong} />

					<AnonRoute path="/" component={Main} />
					</Switch>
			</div>
		);
	}
}

export default withAuth(App);
